// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllDownloadsMediaItemIcon__container-f724b9 {
  min-width: 40px;
  position: relative;
  margin: 4px;
}

.AllDownloadsMediaItemIcon__media-preview-dac5ed {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.AllDownloadsMediaItemIcon__download-state-f2d7ea {
  width: 100%;
  height: 100%;
  border-radius: 0;
}

.AllDownloadsMediaItemIcon__error-icon-border-c028ef {
  position: absolute;
  right: -6px;
  bottom: -6px;
  width: 18px;
  height: 18px;
  border: 1px solid var(--base-0);
  border-radius: 50%;
}

.AllDownloadsMediaItemIcon__error-icon-beef77 {
  position: absolute;
  right: -5px;
  bottom: -5px;
  width: 18px;
  height: 18px;
  color: var(--addition-50);
  fill: var(--danger-40);
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/AllDownloads/AllDownloadsItem/AllDownloadsMediaItem/AllDownloadsMediaItemIcon/AllDownloadsMediaItemIcon.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  min-width: 40px;\n  position: relative;\n  margin: 4px;\n}\n\n.media-preview {\n  position: relative;\n  width: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.download-state {\n  width: 100%;\n  height: 100%;\n  border-radius: 0;\n}\n\n.error-icon-border {\n  position: absolute;\n  right: -6px;\n  bottom: -6px;\n  width: 18px;\n  height: 18px;\n  border: 1px solid var(--base-0);\n  border-radius: 50%;\n}\n\n.error-icon {\n  position: absolute;\n  right: -5px;\n  bottom: -5px;\n  width: 18px;\n  height: 18px;\n  color: var(--addition-50);\n  fill: var(--danger-40);\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AllDownloadsMediaItemIcon__container-f724b9`,
	"media-preview": `AllDownloadsMediaItemIcon__media-preview-dac5ed`,
	"mediaPreview": `AllDownloadsMediaItemIcon__media-preview-dac5ed`,
	"download-state": `AllDownloadsMediaItemIcon__download-state-f2d7ea`,
	"downloadState": `AllDownloadsMediaItemIcon__download-state-f2d7ea`,
	"error-icon-border": `AllDownloadsMediaItemIcon__error-icon-border-c028ef`,
	"errorIconBorder": `AllDownloadsMediaItemIcon__error-icon-border-c028ef`,
	"error-icon": `AllDownloadsMediaItemIcon__error-icon-beef77`,
	"errorIcon": `AllDownloadsMediaItemIcon__error-icon-beef77`
};
module.exports = ___CSS_LOADER_EXPORT___;
